/** Monta a tela declarada por um modulo dentro da PaginaSecao do shell. */
import { type ReactNode } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useIdioma, type Chave } from '../i18n/index.tsx';
import { PaginaSecao } from '../layout/Shell.tsx';
import { useSessao } from '../sessao.tsx';
import type { TelaDeModulo } from './contrato.ts';

/** `topo` entra acima do conteudo da aba: e onde a aba Inicio poe os cards. */
export function TelaDeModuloMontada({ tela, topo }: { tela: TelaDeModulo; topo?: ReactNode }) {
  const { t } = useIdioma();
  const { estado } = useSessao();
  const permissoes = estado.fase === 'dentro' ? estado.eu.permissoes : [];
  const abas = tela.abas.filter((a) =>
    a.permissao === undefined || permissoes.includes(a.permissao));
  // a aba ativa vive na URL (?aba=conferir): o bloco do Inicio leva direto a ela
  const [busca, setBusca] = useSearchParams();
  const ativa = busca.get('aba') ?? abas[0]?.id ?? '';
  const setAtiva = (id: string) => setBusca({ aba: id }, { replace: true });

  // o rotulo pode ser chave de i18n ou texto pronto; `t` devolve a chave
  // de volta quando nao acha, entao isto cobre os dois casos
  const rotular = (v: string) => t(v as Chave);

  const aba = abas.find((a) => a.id === ativa) ?? abas[0];
  const Conteudo = aba?.conteudo;

  return (
    <PaginaSecao
      kicker={rotular(tela.kicker ?? 'app.nome')}
      titulo={rotular(tela.titulo)}
      {...(tela.acao !== undefined
        ? { acao: { rotulo: rotular(tela.acao.rotulo), onClick: tela.acao.aoClicar } }
        : {})}
      abas={abas.map((a) => ({ id: a.id, rotulo: rotular(a.rotulo) }))}
      abaAtiva={aba?.id ?? ''}
      onAba={setAtiva}
    >
      {topo}
      {Conteudo !== undefined ? <Conteudo /> : null}
    </PaginaSecao>
  );
}
